import React, {useCallback, useEffect} from 'react';
import {Navigate, Route, Routes, useMatch, useNavigate} from 'react-router-dom';

import {STATSIG_GATES} from 'src/contexts/statsig-contex';
import {ACCESS_RIGHTS, useAdminAccessRight} from 'src/hooks/access-rights';
import {useEventTracking} from 'src/hooks/useEventTracking';
import {EntitlementsDrawer} from 'src/modules/entitlements';

import {useGateValue} from '@pb/kit-lib-statsig';

import {manageEntitlements} from '../manage-entitlements.module.styl';
import {DATASET_ENTITLEMENTS_PATH, DATASET_NAVIGATION_STATE} from '../utils';

import {DatasetEntitlements} from './dataset-entitlements/dataset-entitlements';
import {Presets} from './presets';
import {RolesGrantsResources} from './roles-grants-resources';


export const AllEntitlements = () => {
    const navigate = useNavigate();
    const isDatasetTab = Boolean(useMatch(`${DATASET_ENTITLEMENTS_PATH}/*`));
    const {manageEntitlementsOpen} = useEventTracking();
    const {hasAccess} = useAdminAccessRight();
    const isDatasetEntitlementsEnabled = useGateValue(STATSIG_GATES.DATASET_ENTITLEMENTS);

    useEffect(() => {
        manageEntitlementsOpen();
    }, [manageEntitlementsOpen]);

    const editNavigationState = isDatasetTab ? DATASET_NAVIGATION_STATE : undefined;

    const navigateToEditResource = useCallback((resourceId: string) => {
        navigate(`resource/${resourceId}`, {state: editNavigationState});
    }, [navigate, editNavigationState]);

    const navigateToEditGrant = useCallback((grantId: string) => {
        navigate(`grant/${grantId}`, {state: editNavigationState});
    }, [navigate, editNavigationState]);

    const navigateToEditRole = useCallback((roleId: string) => {
        navigate(`role/${roleId}`, {state: editNavigationState});
    }, [navigate, editNavigationState]);

    const navigateToEditPreset = useCallback((presetId: string) => {
        navigate(`preset/${presetId}`);
    }, [navigate]);

    return (
        <div className={manageEntitlements}>
            <Routes>
                <Route path="roles-grants" element={<RolesGrantsResources/>}/>
                {hasAccess(ACCESS_RIGHTS.MANAGE_ENTITLEMENT_PRESET) ? (
                    <Route path="/presets" element={<Presets/>}/>
                ) : null}
                {isDatasetEntitlementsEnabled ? (
                    <Route path="/dataset-entitlements" element={<DatasetEntitlements/>}/>
                ) : null}

                <Route path="*" element={<Navigate to="roles-grants" replace={true}/>}/>
            </Routes>
            <EntitlementsDrawer
                stickyToElement=".manage-controls"
                onEditResource={navigateToEditResource}
                onEditGrant={navigateToEditGrant}
                onEditRole={navigateToEditRole}
                onEditPreset={navigateToEditPreset}
            />
        </div>
    );
};
